import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ui-svg-icon',
  imports: [MatIconModule],
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgIconComponent implements OnChanges {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  @Input() svgIcon = '';
  @Input() customClass = '';
  @Input() size: 'small' | 'medium' | 'large' | 'xlarge' = 'large';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['svgIcon'] && this.svgIcon) {
      this.iconRegistry.addSvgIcon(
        this.svgIcon,
        this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icones/${this.svgIcon}.svg`)
      );
    }
  }

  get svgIconClass(): string {
    const baseClass = this.size + '-icon ' + `icon-${this.svgIcon.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
    return this.customClass ? `${this.customClass} ${baseClass}` : baseClass;
  }
}
